import { createNS } from "@ontologies/core";
/** Function to create arbitrary terms within the 'XML Schema Datatypes in RDF and OWL' ontology */
export const ns = createNS("http://www.w3.org/2001/XMLSchema#");
export const string = ns("string");
export const xsdboolean = ns("boolean");
export const decimal = ns("decimal");
export const xsdfloat = ns("float");
export const xsddouble = ns("double");
export const duration = ns("duration");
export const dateTime = ns("dateTime");
export const time = ns("time");
export const date = ns("date");
export const gYearMonth = ns("gYearMonth");
export const gYear = ns("gYear");
export const gMonthDay = ns("gMonthDay");
export const gDay = ns("gDay");
export const gMonth = ns("gMonth");
export const hexBinary = ns("hexBinary");
export const base64Binary = ns("base64Binary");
export const anyURI = ns("anyURI");
export const normalizedString = ns("normalizedString");
export const token = ns("token");
export const language = ns("language");
export const NMTOKEN = ns("NMTOKEN");
export const Name = ns("Name");
export const NCName = ns("NCName");
export const integer = ns("integer");
export const nonPositiveInteger = ns("nonPositiveInteger");
export const negativeInteger = ns("negativeInteger");
export const xsdlong = ns("long");
export const xsdint = ns("int");
export const xsdshort = ns("short");
export const xsdbyte = ns("byte");
export const nonNegativeInteger = ns("nonNegativeInteger");
export const unsignedLong = ns("unsignedLong");
export const unsignedInt = ns("unsignedInt");
export const unsignedShort = ns("unsignedShort");
export const unsignedByte = ns("unsignedByte");
export const positiveInteger = ns("positiveInteger");
export const yearMonthDuration = ns("yearMonthDuration");
export const dayTimeDuration = ns("dayTimeDuration");
export const dateTimeStamp = ns("dateTimeStamp");
export default {
    /** Function to create arbitrary terms within the 'XML Schema Datatypes in RDF and OWL' ontology */
    ns,
    string,
    boolean: xsdboolean,
    decimal,
    float: xsdfloat,
    double: xsddouble,
    duration,
    dateTime,
    time,
    date,
    gYearMonth,
    gYear,
    gMonthDay,
    gDay,
    gMonth,
    hexBinary,
    base64Binary,
    anyURI,
    normalizedString,
    token,
    language,
    NMTOKEN,
    Name,
    NCName,
    integer,
    nonPositiveInteger,
    negativeInteger,
    long: xsdlong,
    int: xsdint,
    short: xsdshort,
    byte: xsdbyte,
    nonNegativeInteger,
    unsignedLong,
    unsignedInt,
    unsignedShort,
    unsignedByte,
    positiveInteger,
    yearMonthDuration,
    dayTimeDuration,
    dateTimeStamp
};
